import { render, staticRenderFns } from "./teacherPublish.vue?vue&type=template&id=0646d148&scoped=true&"
import script from "./teacherPublish.vue?vue&type=script&lang=js&"
export * from "./teacherPublish.vue?vue&type=script&lang=js&"
import style0 from "./teacherPublish.vue?vue&type=style&index=0&id=0646d148&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0646d148",
  null
  
)

export default component.exports